// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zwz1","rootMobile":"styles_rootMobile__1hNYR"};